import React, { ReactElement } from 'react';
import { MutationTrigger } from '@reduxjs/toolkit/dist/query/react/buildHooks';
import { BaseQueryFn } from '@reduxjs/toolkit/query/react';
import { MutationDefinition } from '@reduxjs/toolkit/query';
import { connect } from 'react-redux';
import {
  usePostDemoMutation,
  usePushToCustomContentMutation,
} from '../../../../redux/configuration/demos/api';
import { RootState } from '../../../../redux/store';
import {
  clearTopologyToSave,
  clearTopologyToUpdate,
  topologiesSelectors,
} from '../../../../redux/topologies/slice';
import { getIsFormDirty } from '../../../../redux/configuration/isFormDirty/slice';
import { SaveCustomContentModal } from '.';

const mapStateToProps = (state: RootState) => ({
  isFormDirty: getIsFormDirty(state),
  topologyToSave: topologiesSelectors.getTopologyToSave(state),
  topologyToUpdate: topologiesSelectors.getTopologyToUpdate(state),
});

const mapDispatchToProps = {
  clearTopologyToSave,
  clearTopologyToUpdate,
};

export type SaveCustomContentModalContainerProps = ReturnType<
  typeof mapStateToProps
> &
  typeof mapDispatchToProps;

export type RtkProps = {
  isSaving: boolean;
  saveTopology: MutationTrigger<
    MutationDefinition<
      string,
      BaseQueryFn,
      string,
      DemosPostResponse,
      'dcloudApi'
    >
  >;
  updateDemo: MutationTrigger<
    MutationDefinition<
      DemosUpdatePayload,
      BaseQueryFn,
      string,
      DemosPostResponse,
      'dcloudApi'
    >
  >;
};

export type SaveCustomContentModalProps = SaveCustomContentModalContainerProps &
  RtkProps;

const SaveCustomContentModalContainer = (
  props: SaveCustomContentModalContainerProps,
): ReactElement => {
  const [postTopology, { isLoading }] = usePostDemoMutation({
    fixedCacheKey: 'shared-demo-post',
  });
  const [pushToCustomContent, { isLoading: isUpdating }] =
    usePushToCustomContentMutation({
      fixedCacheKey: 'shared-demo-put',
    });

  return (
    <SaveCustomContentModal
      {...props}
      saveTopology={postTopology}
      updateDemo={pushToCustomContent}
      isSaving={isLoading || isUpdating}
    />
  );
};

export const ConnectedSaveCustomContentModal = connect(
  mapStateToProps,
  mapDispatchToProps,
)(SaveCustomContentModalContainer);
